import { createReducer, on } from "@ngrx/store";
import { Int_ApplicationDetails, Int_UserApplications, Int_DynamicTableColumn, Int_User } from "./mobi-office-ui.interface";
import {
  DELETE_MOBIOFFICE_UI_User,
  GET_MOBIOFFICE_UI_ApplicationDetails,
  GET_MOBIOFFICE_UI_ApplicationDetails_SUCCESS,
  GET_MOBIOFFICE_UI_DynamicTableColumn,
  GET_MOBIOFFICE_UI_DynamicTableColumn_SUCCESS,
  GET_MOBIOFFICE_UI_User,
  GET_MOBIOFFICE_UI_UserApplications,
  GET_MOBIOFFICE_UI_UserApplications_SUCCESS,
  GET_MOBIOFFICE_UI_User_SUCCESS,
} from "./mobi-office-ui.action";

//#region User Reducer

const initialUser: Int_User = {
  UserInfo: {},
};

export const userReducer = createReducer(
  initialUser,
  on(GET_MOBIOFFICE_UI_User, (state: Int_User) => state),
  on(GET_MOBIOFFICE_UI_User_SUCCESS, (state: Int_User, { payload }) => ({ ...state, ...payload })),
  on(DELETE_MOBIOFFICE_UI_User, (state: Int_User) => {
    const payload: Int_User = {
      UserInfo: {},
    };
    return { ...state, ...payload };
  })
);

//#endregion

//#region Dynamic Table Columns

export const initialDynamicTableColumn: Int_DynamicTableColumn = {
  IsLoaded: false,
};

export const dynamicTableColumnReducer = createReducer(
  initialDynamicTableColumn,
  on(GET_MOBIOFFICE_UI_DynamicTableColumn, (state: any) => state),
  on(GET_MOBIOFFICE_UI_DynamicTableColumn_SUCCESS, (state, { payload }) => {
    return { ...state, ...payload };
  })
);

//#endregion

//#region Application Details

export const initialApplicationDetails: Int_ApplicationDetails = {
  ApplicationDetails: {},
  IsLoaded: false,
};

export const applicationDetailsReducer = createReducer(
  initialApplicationDetails,
  on(GET_MOBIOFFICE_UI_ApplicationDetails, (state: any) => state),
  on(GET_MOBIOFFICE_UI_ApplicationDetails_SUCCESS, (state, { payload }) => {
    return { ...state, ...payload };
  })
);

//#endregion

//#region Application Details

export const initialUserApplications: Int_UserApplications = {
  ApplicationsList: [],
  IsLoaded: false,
};

export const userApplicationsReducer = createReducer(
  initialUserApplications,
  on(GET_MOBIOFFICE_UI_UserApplications, (state: any) => state),
  on(GET_MOBIOFFICE_UI_UserApplications_SUCCESS, (state, { payload }) => {
    return { ...state, ...payload };
  })
);

//#endregion
